export type PreviewModuleCounts = {
  active: boolean;
  shadowCount: number;
  removeCount: number;
};

const EMPTY_PREVIEW_COUNTS: PreviewModuleCounts = {
  active: false,
  shadowCount: 0,
  removeCount: 0,
};

let previewCounts: PreviewModuleCounts = EMPTY_PREVIEW_COUNTS;
const listeners = new Set<(counts: PreviewModuleCounts) => void>();

export function getPreviewModuleCounts() {
  return previewCounts;
}

export function previewModuleOffset(
  preview: PreviewModuleCounts,
  reduxShadowCount: number,
  reduxRemoveCount: number,
) {
  if (preview.active) {
    return preview.shadowCount - preview.removeCount;
  }
  return reduxShadowCount - reduxRemoveCount;
}

export function setPreviewModuleCounts(next: PreviewModuleCounts) {
  if (
    previewCounts.active === next.active
    && previewCounts.shadowCount === next.shadowCount
    && previewCounts.removeCount === next.removeCount
  ) {
    return;
  }
  previewCounts = next;
  listeners.forEach((listener) => listener(previewCounts));
}

export function resetPreviewModuleCounts() {
  setPreviewModuleCounts(EMPTY_PREVIEW_COUNTS);
}

export function subscribePreviewModuleCounts(listener: (counts: PreviewModuleCounts) => void) {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}
